<template>
  <div class="w-full flex justify-between">
    <div class="flex items-center gap-x-2 w-full">
      <div class="w-1/12">
        <slot name="icon"></slot>
      </div>

      <h4
        :class="{ 'font-bold text-brand-red': attachmentType.isMandatory }"
        class="flex items-center gap-x-1 w-full"
      >
        <div class="flex flex-col gap-y-1.5">
          <div class="flex items-center gap-x-1 w-full">
            <span
              :class="{
                'text-brand-green': isAttached,
                'text-brand-red':
                  attachmentType.hasIntegration && attachmentType.integrationDetailsNoFound
              }"
              class="text-sm"
            >
              {{ attachmentType.localizedName }}
              <span class="text-xs">
                {{ $t(attachmentType.isMandatory ? 'Required' : 'Optional') }}
              </span>
            </span>
            <HintTyppy
              v-if="
                !globalStore?.clientConfig?.enableICAOPersonalPhotoConditions &&
                attachmentType.id === 141
              "
              hint="personalPhotoWorningMessage"
            ></HintTyppy>
          </div>
          <div
            v-if="attachmentType.hasIntegration && attachmentType.integrationDetailsNoFound"
            class="flex gap-3"
          >
            <faTriangleExclamation class="fill-yellow-500 w-4" />
            <p class="text-xs text-yellow-500">{{ $t('NoDataFoundInIntegration') }}</p>
          </div>
        </div>
      </h4>
    </div>

    <div class="w-3/12">
      <slot name="end"></slot>
    </div>
  </div>
</template>

<script setup>
import client_config from '@/assets/json/client_config.json'
import { useFormStore } from '@/stores/form'
import { useGlobalStore } from '@/stores/global'
import faTriangleExclamation from '@/assets/icons/faTriangleExclamation.svg'

import HintTyppy from '@/components/Form/HintTyppy.vue'
import { computed } from 'vue'
const globalStore = useGlobalStore()
const props = defineProps({
  attachmentType: Object
})

const formStore = useFormStore()

const isAttached = computed(() => {
  return formStore.attachments.some((att) => att.attachmentTypeId === props.attachmentType.id)
})
</script>

<style lang="scss" scoped></style>
